import Vue from 'vue';
import { ui } from '@/constants';
import { Component, Prop } from 'vue-property-decorator';
import { MonoMenuCacheItem, MonoMenuEntreeGroup, MonoMenuTileItem } from '@/models';
import { isDefined } from '@/helpers';

@Component({
  name: 'CmgNutritionCalculatorMealBuilderGroup',
})
export default class CmgNutritionCalculatorMealBuilderGroup extends Vue {
  private expanded: boolean = true;
  private validationErrorMargin: string = '';
  private mobileExpandedGroups: string[] = ['INCLUDED INGREDIENT', 'PROTEIN OR VEGGIE', 'Rice', 'Beans', 'Top Things Off', 'Tortilla', 'LIFESTYLE BOWL', 'Options', 'included sides', 'Included Toppings']; //TODO: maybe it would be easier to make groups expanded by defualt? 

  @Prop({ required: true, type: Object })
  group?: MonoMenuEntreeGroup;

  get isExpanded(): boolean {
    return this.expanded;
  }

  get getCollapseUrl(): string {
    return this.$appStore.state.cms.images.icons.removeLarge.default;
  }

  get getExpandUrl(): string {
    return this.$appStore.state.cms.images.icons.addLarge.default;
  }

  get groupType(): string {
    return this.group?.type ?? '';
  }

  get items(): MonoMenuTileItem[] {
    if (this.groupType === 'pce') {
      return this.$services.mealBuilderV2.getLifestyleBowlsTiles();
    } else if (this.groupType === 'entree') {
      return this.group!.items.map(id => (this.$services.monoMenu.getMonoMenuEntree(id, true)) as MonoMenuTileItem).filter(this.$services.monoMenu.isItemAvailable);
    } else if (this.groupType) {
      return this.group!.items.map(id => (this.$services.monoMenu.getMonoMenuItem(id, true)) as MonoMenuTileItem).filter(this.$services.monoMenu.isItemAvailable);
    }

    return [];
  }

  get nutritionSections(): any[] {
    return this.$services.monoMenu.getTopLevelMenuNutritionDetailSections();
  }

  get isDesktop(): boolean {
    return this.$appStore.state.ui.clientWidth >= ui.breakpoints.desktop;
  }

  get showValidationError(): boolean {
    return !!this.group?.contentGroupName && !!this.$appStore.state.mealBuilderV2.sectionErrors[this.group.contentGroupName];
  }

  get validationErrorMessage(): string {
    this.validationErrorMargin = 15 + (this.$refs.title as HTMLElement).clientWidth + 'px';
    return !!this.group?.contentGroupName ? this.$appStore.state.mealBuilderV2.sectionErrors[this.group.contentGroupName] : '';
  }

  get isRendered(): boolean {
    return !!(this.$refs.title as HTMLElement);
  }

  mounted() {
    if (!this.isMobileExpandedGroup(this.group?.title ?? '') && this.$appStore.state.mealBuilderV2.topLevelMenuItemTitle !== 'Sides & Drinks') {
      this.expanded = false;
    }
  }

  toggleAccordion() {
    this.expanded = !this.expanded;
    this.$emit('group-toggled');
  }

  isMobileExpandedGroup(groupTitle: string): boolean {
    return this.mobileExpandedGroups.indexOf(groupTitle) > -1;
  }
}
